export default {"src":"/_next/static/media/contactpetsitters.8a9b8cde.svg","height":32,"width":33,"blurWidth":0,"blurHeight":0};